import React from 'react'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  root: {
    margin: 0,
    padding: `${theme.spacing.unit}px 0`,
    paddingBottom: theme.spacing.unit * 10,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 10
    },
    [theme.breakpoints.up('md')]: {
      width: theme.breakpoints.values.md,
      margin: `${theme.spacing.unit}px auto`
    }
  }
})

export const ContentBase = ({ children, classes }) => (
  <div className={classes.root}>{children}</div>
)

export const Content = withStyles(styles)(ContentBase)
